module.exports = __webpack_public_path__ + "static/img/Cover-AZ-B.ca16c160.jpg";